import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector, useDispatch } from 'react-redux';
import { withResponsive } from '@brighte/brighte-one-native';
import withTokenRefresh from '../../hoc/withTokenRefresh';
import Verification from './Verification';
import { getAuthService } from '../../AuthService';
import { paramsFromURL } from '../../utilities';
import { adminLoginRequest } from '../../actions';

const Admin = () => {
  const { identity, initData } = useSelector((state: Record<string, any>) => state.appData);
  const { code } =  paramsFromURL();
  const dispatch = useDispatch();

  useEffect(() => {
    // Once authenticated, never restart the login redirect just because `code` looks empty —
    // AuthService.completeLogin() strips ?code=...&state=... from the URL after processing it,
    // which would otherwise re-run this effect (code changed from a value to empty) and call
    // login() again on every re-render triggered by identity being set. With an active Auth0
    // session that redirect silently re-approves and comes straight back with a fresh code,
    // which strips again, which re-renders again — an infinite redirect loop.
    if (!isEmpty(identity)) {
      return;
    }
    if (isEmpty(code)) {
      getAuthService().login();
    } else {
      dispatch(adminLoginRequest())
    }
  }, [code, dispatch, identity])

  if (!isEmpty(identity)) {
    return <Verification {...initData} />
  }

  return !isEmpty(code) ? (
    <p>Verifying ...</p>
  ) : (
    <p>Redirecting ...</p>
  );
};

export default withResponsive(withTokenRefresh(Admin));
